import React, { useState } from 'react';
import { Typography, ShowMore } from '@guildeducationinc/recess';
import { GetMemberProgramQuery } from 'src/graphqlTypes/catalogServiceTypes';
import { About } from 'src/components/ProgramDetails/Institution/About';
import { Reasons } from 'src/components/ProgramDetails/Institution/Reasons';
import { Skeleton } from 'src/components/UserFacetSkeletonLoader';
import styles from './Institution.module.scss';

interface Props {
	program: GetMemberProgramQuery['memberProgram'];
	loading: boolean;
}

export const Institution: React.FC<Props> = ({ program, loading }) => {
	const [showImage, setShowImage] = useState(true);

	return (
		<section
			aria-label='institution'
			className={styles.sectionContainer}
			data-testid='program-detail-institution'
			data-title='About the school'
			id='detail-about-the-school'
			tabIndex={-1}
		>
			<Typography className={styles.title} variant='h2'>
				About the school
			</Typography>

			<Skeleton dataLoading={loading} height={270}>
				<ShowMore initialHeight={250} panelId='institution' testId='show-more-button'>
					<About program={program} setShowImage={setShowImage} showImage={showImage} />
					<Reasons program={program} />
				</ShowMore>
			</Skeleton>
		</section>
	);
};
